<template>
  <layout-vertical>

    <router-view />

  </layout-vertical>
</template>

<script>
import LayoutVertical from '@core/layouts/layout-vertical/LayoutVertical.vue'
import useNotifications from '@/composables/useNotifications'

export default {
  components: {
    LayoutVertical,
  },
  data() {
    return {
    }
  },
  created() {
    // Connects the notification socket + primes the navbar badge exactly
    // once per page load - this layout wraps every authenticated page, so
    // it's the right place to bootstrap it rather than each individual view.
    useNotifications().init()
  },
}
</script>
